import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "@/lib/auth-context";
import { Icon } from "@/components/Icon";

// React Router 7 port of components/MarketingNav.tsx. The Next.js original
// stays untouched so its production build keeps working until the Phase 6
// cutover deletes it.

const links = [
  { to: "/", label: "Acasă" },
  { to: "/functii", label: "Funcții" },
  { to: "/app", label: "Aplicația web" },
  { to: "/despre", label: "Despre" },
  { to: "/intrebari", label: "Întrebări" },
];

export function MarketingNav() {
  const { pathname } = useLocation();
  const { user, loading } = useAuth();
  const [open, setOpen] = useState(false);
  // React 19 "set-state-in-effect" alternative — store the previous value
  // and compare during render so the drawer-reset happens in the same
  // commit. Same idiom as the Next.js sibling component.
  const [lastPath, setLastPath] = useState(pathname);
  if (lastPath !== pathname) {
    setLastPath(pathname);
    setOpen(false);
  }

  return (
    <nav className="nav">
      <div className="shell nav-inner">
        <Link to="/" className="nav-brand">
          <span className="nav-brand-mark">
            <img src="/simple_icon.svg" alt="" width={36} height={24} />
          </span>
          Asistent Auto
        </Link>
        <div className="nav-links">
          {links.map((l) => {
            const active =
              l.to === "/" ? pathname === "/" : pathname.startsWith(l.to);
            return (
              <Link
                key={l.to}
                to={l.to}
                className={`nav-link${active ? " is-active" : ""}`}
              >
                {l.label}
              </Link>
            );
          })}
        </div>
        <div className="nav-cta">
          {loading ? null : user ? (
            <Link to="/masini" className="btn btn--primary">
              <Icon name="dashboard" />
              <span className="nav-cta-label">Aplicație</span>
            </Link>
          ) : (
            <>
              <Link to="/cont/login" className="btn btn--secondary">
                Intră în cont
              </Link>
              <a href="#download" className="btn btn--primary">
                <Icon name="download" />
                <span className="nav-cta-label">Descarcă</span>
              </a>
            </>
          )}
          <button
            type="button"
            className="nav-burger"
            aria-label={open ? "Închide meniul" : "Deschide meniul"}
            aria-expanded={open}
            aria-controls="nav-mobile-drawer"
            onClick={() => setOpen((o) => !o)}
          >
            <Icon name={open ? "close" : "menu"} />
          </button>
        </div>
      </div>
      {open && (
        <div
          id="nav-mobile-drawer"
          className="nav-mobile-drawer"
          onClick={() => setOpen(false)}
        >
          {links.map((l) => {
            const active =
              l.to === "/" ? pathname === "/" : pathname.startsWith(l.to);
            return (
              <Link
                key={l.to}
                to={l.to}
                className={`nav-mobile-link${active ? " is-active" : ""}`}
              >
                {l.label}
              </Link>
            );
          })}
          {/* Phones hide the header's "Intră în cont" button; it lives here. */}
          {!loading && !user ? (
            <Link
              to="/cont/login"
              className="nav-mobile-link nav-mobile-link--signin"
            >
              Intră în cont
            </Link>
          ) : null}
        </div>
      )}
    </nav>
  );
}
